import { render } from "./MobilePromoBar.vue?vue&type=template&id=0180ca3a&scoped=true"
import script from "./MobilePromoBar.vue?vue&type=script&lang=js"
export * from "./MobilePromoBar.vue?vue&type=script&lang=js"

import "./MobilePromoBar.vue?vue&type=style&index=0&id=0180ca3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0180ca3a"]])

export default __exports__